// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button--wrapper--1zQJ5"};